import $ from 'jquery';
import { createMap } from 'map';
import Feature from 'ol/Feature';

/*global OLUtils */

function onMapReady(vdMap) {
    const wkts = $('input[name=geometry]');
    $.each(wkts, (_index, siteWkt) => {
        const wkt = $(siteWkt).val();
        if (wkt.length > 0) {
            const f = OLUtils.toFeature(wkt);
            if (!!f) {
                if (f.getGeometry().getType() === "GeometryCollection") {
                    $.each(f.getGeometry().getGeometries(), function (_index2, geometry) {
                        const feature = new Feature({ geometry });
                        vdMap.addGeometry(feature);
                    });
                } else {
                    vdMap.addGeometry(f);
                }
            }
            vdMap.zoomToContents();
        }
    });
}

$(() => {
    $('#summaryMap').css({ marginBottom: '20px' });
    if (typeof gpxPaths === "undefined") {
        createMap("summaryMap", null, [], {}, [])
            .then(onMapReady);
    } else {
        createMap("summaryMap", null, [], {}, [])
            .then(vdMap => {
                gpxPaths.forEach(wkt => vdMap.addSection(wkt));
                vdMap.zoomToContents();
            });
    }
});
